import React from "react";
import {
    Modal,
    Box,
    Typography,
    IconButton,
    Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

const ModalWrapper = ({
    open,
    setOpen,
    onClose,
    title,
    subtitle,
    actions,
    content,
    width = "50vw",
    contentRef,
    headerActions = null,
    fullscreen = false,
}) => {
    const { t } = useTranslation();
    
    // Set default translated values if not provided
    const finalTitle = title || t('TITLES.CONFIRM_ACTION');
    const finalSubtitle = subtitle || t('TITLES.REVIEW_DETAILS_AND_CONTINUE');
    const handleClose = () => {
        if (onClose) onClose();
        setOpen(false);
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: fullscreen ? { xs: "2%", sm: "2%" } : "50%",
                    left: "50%",
                    transform: fullscreen ? "translateX(-50%)" : "translate(-50%, -50%)",
                    width: fullscreen ? { xs: "96%", sm: "96%" } : { xs: "90%", sm: width },
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    borderRadius: 2,
                    p: 2,
                    outline: "none",
                    maxHeight: fullscreen ? "96vh" : "80vh",
                    height: fullscreen ? "96vh" : "auto",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {/* Header */}
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ flexShrink: 0 }}
                >
                    <Box>
                        <Typography variant="h6" fontWeight={600}>
                            {finalTitle}
                        </Typography>
                        {finalSubtitle && (
                            <Typography variant="body2" fontSize={"11px"} color="text.secondary">
                                {finalSubtitle}
                            </Typography>
                        )}
                    </Box>
                    <Stack direction="row" spacing={1} alignItems="center">
                        {headerActions}
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                </Stack>

                {/* Content */}
                <Box
                    ref={contentRef}
                    sx={{
                        flexGrow: 1,
                        overflowY: "auto",
                        my: 2,
                        minHeight: '200px',
                        p: 1,
                        pr: 1, // avoid scrollbar overlap
                    }}
                >
                    {content}
                </Box>

                {/* Actions */}
                {actions && (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 1,
                            flexShrink: 0,
                            pt: 1,
                        }}
                    >
                        {actions}
                    </Box>
                )}
            </Box>
        </Modal>
    );
};

export default ModalWrapper;
